import { render, staticRenderFns } from "./v-input.vue?vue&type=template&id=2a853453&scoped=true&"
import script from "./v-input.vue?vue&type=script&lang=js&"
export * from "./v-input.vue?vue&type=script&lang=js&"
import style0 from "./v-input.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./v-input.vue?vue&type=style&index=1&id=2a853453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a853453",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a853453')) {
      api.createRecord('2a853453', component.options)
    } else {
      api.reload('2a853453', component.options)
    }
    module.hot.accept("./v-input.vue?vue&type=template&id=2a853453&scoped=true&", function () {
      api.rerender('2a853453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v-input.vue"
export default component.exports